<template>
  <div class="h-full" :id="id">
    <WidgetsBaseComponent
      :widget="widget"
      :view-only-mode="viewOnlyMode"
      :subscribe-only-mode="subscribeOnlyMode"
      :loading="false"
      :connectable="false"
      :horizontal-padding="false"
      @expand="goToExpandLink"
    >
      <template #body>
        <div class="flex h-full flex-1" :class="!bothVertically && !bothHorizonally ? 'flex-col overflow-hidden' : ''">
          <div v-if="!bothVertically && !bothHorizonally" class="space-y-2">
            <BaseRadio v-model="selectedView" :options="viewOptions" class="pl-2 pt-2" />
            <BaseDivider />
          </div>
          <div class="flex flex-1" :class="[bothClass, bothClass == 'flex-row' ? 'space-x-2' : 'space-y-2']">
            <div
              v-if="selectedView === 'Fees' || bothVertically || bothHorizonally"
              :class="[bothHorizonally ? 'w-1/2' : 'w-full', bothVertically && !bothHorizonally ? 'h-1/2' : 'h-full']"
            >
              <GasFeeTable />
            </div>
            <div
              v-if="selectedView === 'Historical Chart' || bothVertically || bothHorizonally"
              :class="[
                bothHorizonally ? 'w-1/2' : 'w-full',
                bothVertically && !bothHorizonally ? 'h-1/2' : 'h-full',
                'space-y-1'
              ]"
            >
              <GasFeeChart
                :timeframe="selectedTimeframe"
                :type="selectedType"
                :widget-id="widget.id"
                @update:timeframe="selectedTimeframe = $event"
                @update:type="selectedType = $event"
              />
            </div>
          </div>
        </div>
      </template>
    </WidgetsBaseComponent>
  </div>
</template>

<script>
import WidgetsMixin from '@/mixins/widgets';
import GasFeeTable from '@/components/gas_fee/GasFeeTable.vue';
import GasFeeChart from '@/components/gas_fee/GasFeeChart.vue';
export default {
  name: 'WidgetsGasOverview',
  mixins: [WidgetsMixin],
  components: {
    GasFeeTable,
    GasFeeChart
  },
  data() {
    return {
      viewOptions: ['Fees', 'Historical Chart'],
      selectedView: this.widget?.configuration?.view || 'Historical Chart',
      selectedDate: this.widget?.configuration?.date || [],
      selectedTimeframe: this.widget?.configuration?.chartTimeframe || 1,
      selectedType: this.widget?.configuration?.chartType || 'avg_gwei'
    };
  },
  computed: {
    bothVertically() {
      return this.h >= this.w * 1.66 || this.h >= 35;
    },
    bothHorizonally() {
      return this.w >= this.h * 2.8 || this.w >= 50;
    },
    bothClass() {
      if (this.bothVertically && this.bothHorizonally) return 'flex-row';
      else if (this.bothVertically) return 'flex-col';
      else return 'flex-row';
    }
  },
  methods: {
    async updateWidgetConfig() {
      if (!this.viewOnlyMode) {
        let payload = {
          configuration: {
            ...this.widget.configuration,
            view: this.selectedView,
            date: this.selectedDate,
            chartTimeframe: this.selectedTimeframe,
            chartType: this.selectedType
          }
        };
        await this.$http.patch(`/dashboard_widgets/${this.widget.id}`, payload);
      }
    }
  },
  watch: {
    selectedView() {
      this.updateWidgetConfig();
    },
    selectedDate() {
      this.updateWidgetConfig();
    },
    selectedTimeframe() {
      this.updateWidgetConfig();
    },
    selectedType() {
      this.updateWidgetConfig();
    },
    'widget.configuration.date'() {
      this.selectedDate = this.widget.configuration?.date || [];
    }
  }
};
</script>
